// frontend/src/UserAvatarDropdown.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import defaultAvatar from './assets/default-avatar.png';
import './UserAvatarDropdown.css';
import DonateButton from './DonateButton';

// Utility function to read the CSRF token from cookies
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function UserAvatarDropdown() {
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [donateModalOpen, setDonateModalOpen] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(5); // Default donation amount
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/user/', { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => setUser(data))
      .catch((err) => console.error('Error fetching user:', err));
  }, []);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleSignIn = () => {
    window.location.href = '/accounts/login/';
  };

  const handleSignUp = () => {
    window.location.href = '/accounts/signup/';
  };

  const handleSignOut = () => {
    window.location.href = '/accounts/logout/';
  };

  const handleViewProfile = () => {
    if (user) {
      navigate(`/users/${user.id}`);
      setDropdownOpen(false);
    }
  };

  const handleEditProfile = () => {
    if (user) {
      navigate(`/users/${user.id}`);
      setDropdownOpen(false);
    }
  };

  const openFeedbackModal = () => {
    setFeedbackModalOpen(true);
    setDropdownOpen(false);
  };

  // Open the Donate modal
  const handleDonate = () => {
    setDonateModalOpen(true);
    setDropdownOpen(false);
  };

  const closeDonateModal = () => setDonateModalOpen(false);

  // Donation submission logic to create a Stripe checkout session
  const handleDonateSubmit = () => {
    fetch('/api/create-checkout-session/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
      },
      credentials: 'include',
      body: JSON.stringify({ amount: selectedAmount * 100 }), // amount in cents
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          alert('Error creating checkout session');
        }
      })
      .catch((err) => {
        console.error('Error:', err);
        alert('Error connecting to server.');
      });
  };

  const avatarSrc = user?.profile_picture || defaultAvatar;

  return (
    <div className="user-avatar-dropdown">
      <img
        src={avatarSrc}
        alt="User avatar"
        className="user-avatar"
        onClick={toggleDropdown}
      />
      {dropdownOpen && (
        <div className="dropdown-menu">
          {user ? (
            <>
              <div className="dropdown-item" onClick={handleViewProfile}>
                View Profile
              </div>
              <div className="dropdown-item" onClick={handleEditProfile}>
                Edit Profile
              </div>
              <div className="dropdown-item" onClick={handleDonate}>
                Donate
              </div>
              <div className="dropdown-item" onClick={openFeedbackModal}>
                Feedback
              </div>
              <div className="dropdown-item" onClick={handleSignOut}>
                Sign Out
              </div>
            </>
          ) : (
            <>
              <div className="dropdown-item" onClick={handleSignIn}>
                Sign In
              </div>
              <div className="dropdown-item" onClick={handleSignUp}>
                Sign Up
              </div>
            </>
          )}
        </div>
      )}

      {/* Donate Modal */}
      {donateModalOpen && (
        <div className="donation-modal">
          <div className="modal-content">
            <button className="close-button" onClick={closeDonateModal}>
              &times;
            </button>
            <h2>Support Us</h2>
            <p>Select an amount or enter a custom one:</p>
            <div className="donation-options">
              {[3, 5, 10].map((amount) => (
                <button
                  key={amount}
                  className={`amount-button ${selectedAmount === amount ? 'selected' : ''}`}
                  onClick={() => setSelectedAmount(amount)}
                >
                  ${amount}
                </button>
              ))}
              <input
                type="number"
                min="1"
                placeholder="Custom"
                value={selectedAmount}
                onChange={(e) => setSelectedAmount(Number(e.target.value))}
              />
            </div>
            <button className="confirm-donate-button" onClick={handleDonateSubmit}>
              Donate ${selectedAmount}
            </button>
          </div>
        </div>
      )}

      {/* Feedback Modal */}
      {feedbackModalOpen && (
        <div className="create-event-modal">
          <div className="modal-content">
            <button className="close-button" onClick={() => setFeedbackModalOpen(false)}>
              &times;
            </button>
            <h2>Feedback</h2>
            <p>
              We appreciate your opinion! Send us your feedback about the app at{' '}
              <a href="mailto:contact@hikegroups.com">contact@hikegroups.com</a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserAvatarDropdown;

